import { fetchApprovedTaskDeliverables } from './effects';
import { $approvedTaskDeliverables } from './states';

// Fetch task deliverables
$approvedTaskDeliverables.on(fetchApprovedTaskDeliverables.doneData, (_, data) => data);
